var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-text-field", {
    attrs: {
      height: _vm.height,
      label: _vm.label,
      value: _vm.numberValue,
      rules: _vm.rules,
      disabled: _vm.disabled
    },
    on: { input: _vm.handleInput }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db0c8e9e", { render: render, staticRenderFns: staticRenderFns })
  }
}